export default __webpack_public_path__ + "static/media/103_zip-zap.a2a11861.webp";